module.exports = __webpack_public_path__ + "assets/img/firefox.475e8e5f.svg";